import { Input, Tooltip } from 'antd';
import SearchGlobalIcon from 'Components/common/assets/svgIcons/SearchGlobalIcon';
import Cross from 'Components/globalSearch/assets/Cross';
import React, { useEffect, useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import styled from 'styled-components';
import { FocusRefObj, useFocus } from 'Utils/hooks/useFocus';
import {
  IsMobileSm, getLangCookie, validateSearchQuery,
} from 'Utils/UtilityFunctions';
import {
  boxShadow, maxTablet, maxWidth, midMobile, primaryBgColor,
  primaryColor, primaryFont, retina, secondaryFont, smMobile, wLight, wMBold,
} from 'Utils/utilsStyle';
import { actions } from 'Slice/AffinitySearchResultsSlice';
import { SearchResultsRequest } from 'Types/AffinitySearchTypes';
import {
  useDispatch, useSelector,
} from 'react-redux';

import { actions as personProfileActions } from 'Slice/PersonProfileSlice';
import AffinitySearchNameSkeleton from 'Components/common/skeleton/AffinitySearchNameSkeleton';
import { selectSearchText } from 'Selector/AffinitySearchSelector';
import { usePrevious } from 'Utils/hooks/usePrevious';
import { Executive } from 'Types/PersonTypes';
import { selectSearchedLoading, selectSearchedPerson, selectSearchedPersonData } from 'Selector/PersonProfileSelector';

import { actions as certificationActions } from 'Slice/CertificationSlice';
import { selectData } from 'Selector/CertificationSelector';
import { Waypoint } from 'react-waypoint';
import classNames from 'classnames';
import { translateSkipAreas } from 'Utils/Constants';
import AffinitySearchPopup from './AffinitySearchPopup';
import { AffinitySearchResults } from './AffinitySearchResults';

type Props = {
  // iconMode: boolean;
  name: string;
  loading: boolean;
  defaultOpen: boolean
  profileId: number
  showPopUp: number
};

const SearchWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media all and (max-width: ${midMobile}) {
    width: 100%;
  }

  &.s-disable {
    background-color: ${primaryBgColor};
    pointer-events: none;
    opacity: 0.5;
    cursor: no-drop;
    input {
      background-color: transparent;
    }
  }

  &.shrink-mode{
    min-width: 100%;
    height:33px;
    margin-right: 10px;
    @media all and (max-width: ${maxWidth}) , ${retina} { 
      margin-right: 8px;
    }
    .ant-dropdown {
      display: block;
    }
  }
  &.icon-mode {
    border: none;
    .ant-input-affix-wrapper {
      /* padding: 0px 29px 0px 0px; */
      padding: 0px;
      margin-top: 5px;
      border-radius: 0px;
      border: none;
      input {
        display: none;
      }
      .ant-input-prefix {
        &:focus-visible {
          outline: none;
        }
        svg {
          cursor: pointer;
        }
      }
    }
    .ant-input-prefix {
     padding: 0px;
     border-right: none;
     margin-right: 0px;
      svg {
        height: 19px;
      }
    }
    .clear-search {
      display: none;
    }
  }
  &.large-mode{
    min-width: 580px;
    background:white;
    border-radius: 27px;
    box-shadow: ${boxShadow};
    background-color: transparent;
    border-radius: 25px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      min-width: 580px;
    }
    .ant-dropdown {
      display: block;
      top: 20px !important;
    }
  }
  .ant-dropdown {
    top: 20px !important;
    z-index: -1;
    padding-top: 20px;
    background-color: #fff;
    border: 1px solid #C1C1C1;
    border-radius: 0px 0px 25px 25px;
    display: none;
  }

  .search-field {
    border-radius: 27px;
    &.ant-input-affix-wrapper-lg {
      position: absolute;
      top: -1px;
      right:  -3px;
      z-index:unset;
      transition: none;
    }
  }

  .clear-search {
    position: absolute;
    right: 2%;
    z-index: 1;
    &.shrink-mode-positioning{
      top: 11px;
      right: 27px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        top: 11px;
        right: 22px;
      }
      @media all and (max-width: ${maxTablet}) {
        top: 12px;
        right: 9px;
      }
    }
  }
  .disabled{
    opacity:0;
    display:none;
    pointer-events:none;
  }
  .pointer-cursor{
    cursor:pointer
  }
  .ant-input-affix-wrapper {
    padding: 3px 34px 3px 11px;
     @media all and (max-width: ${maxWidth}) , ${retina} {
          padding: 3px 30px 3px 11px;
     }
     input {
       font-weight: ${wLight};
       font-size:13px;
       font-family: ${primaryFont};
       @media all and (max-width: ${maxWidth}) , ${retina} {
          font-size: 13px;
        }
     }
    &:focus {
      border-color: ${primaryColor};
      box-shadow: none;
    }
    &:hover {
      border-color: ${primaryColor};
    }
  }
  .ant-input-prefix {
    margin-right: 8px;
    padding-right: 8px;
    border-right: 2px solid #c1c1c1;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      margin-right: 4px;
      padding-right: 8px;
    }
    svg {
     width: auto;
     height: 18px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        height: 14px;
      }
    }
  }
  .ant-input {
    &:focus {
      border-color: ${primaryColor};
    }
  }
  .ant-form-input-control,
  .input.ant-input,
  .input.ant-input:focus {
    outline: none;
    box-shadow: none;
    border: 2px solid ${primaryColor};
  }
  &.z-index-1{
    z-index: 1;
  }
  &.min-height {
    &.personYouName {
      @media all and (max-width: ${midMobile}) {
        width: 100%;
      }
      @media all and (max-width: ${smMobile}){
        width: auto;
      }
    }
    min-height: 40px;
    @media all and (max-width: ${maxTablet}){
      width: 150px;
    }
    @media all and (max-width: ${midMobile}) {
      .search-field-text {
        margin-left: 0;
        max-width: 149px;
      }
    }
    @media all and (max-width: ${smMobile}){
      width: 100%;
      max-width: 115px;
      min-height: 20px;
      pointer-events: none;
      .search-field-text {
        font-size: 12px;
      }
    }
  }
  .input-dropdown-wrapper {
    &:focus-visible {
      outline: none;
    }
  }  
`;

const PersonName = styled.div`
  font-family: ${secondaryFont};
  font-size: 14px;
  font-weight: ${wMBold};
  display: inline-block;
  width: auto;
  text-align: center;
  margin-top: 4px;
  margin-left: 8px;
`;

const AffinitySearch = function AffinitySearch(props: Props) {
  const {
    name, loading, defaultOpen, profileId, showPopUp,
  } = props;
  const [visible, setVisiblePopup] = useState(false);
  const [searchText, setSearchText] = useState<string>('');
  const [isCrossVisible, setIsCrossVisible] = useState(false);
  const [isLargeMode, setIsLargeMode] = useState(false);
  const previousIsLargeMode = usePrevious(isLargeMode);
  const searchedTerm = useSelector(selectSearchText);
  const selectedPerson: Executive = useSelector(selectSearchedPerson);
  const affintyLoading = useSelector(selectSearchedLoading);
  const persons = useSelector(selectSearchedPersonData);
  const isMobSm = IsMobileSm();
  const dispatch = useDispatch();
  const personYouFlag = (name === 'You');
  const {
    htmlElementRef: inputRef,
    setFocus: setFocusOnInput,
  }: FocusRefObj = useFocus();

  const enableLargeMode = () => {
    setIsLargeMode(true);
    setFocusOnInput();
  };

  const disableLargeMode = () => {
    setIsLargeMode(false);
  };

  const onBlur = () => {
    disableLargeMode();
    if (searchText === '') {
      //dispatch(personProfileActions.resetSelectedSearchedPerson());
    }
  };

  const MODES: Record<string, string> = {
    LARGE: 'LARGE',
    SMALL: 'SMALL',
    ICON: 'ICON',
  };
  const modeCSSMap: Record<string, string> = {
    LARGE: 'large-mode',
    SMALL: 'shrink-mode',
    ICON: 'icon-mode',
  };

  const searchMode: string = (() => {
    if (isLargeMode) {
      return MODES.SMALL;
    }
    return MODES.ICON;
  })();

  const onSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchQuery = validateSearchQuery(e?.target?.value);
    if (searchQuery.length === 0) {
      setSearchText('');
      setIsCrossVisible(false);
      dispatch(actions.affinitySearchResultReset());
      return;
    }
    setSearchText(searchQuery);
    setIsCrossVisible(true);
    // setFocusOnInput();
  };

  const data = useSelector(selectData);

  const triggerSearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      dispatch(certificationActions.certificationAction({
        type: 'affinity_search',
        source: 'person',
        data,
      }));
      const searchQuery = validateSearchQuery(searchText.trim());
      if (searchQuery.length === 0 || searchQuery === searchedTerm) {
        return;
      }
      const obj: SearchResultsRequest = {
        query: searchQuery.trim(),
        screenName: 'person',
        page: 1,
        defaultLanguage: getLangCookie(),
      };
      dispatch(actions.affinitySearchResultReset());
      dispatch(actions.affinitySearchResultsLoading(obj));
    }
  };

  const clearSearch = (e: React.MouseEvent<HTMLOrSVGElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setSearchText('');
    if (isLargeMode) {
      setIsLargeMode(false);
    }
    setIsCrossVisible(false);
    dispatch(personProfileActions.resetSelectedSearchedPerson());
    dispatch(actions.affinitySearchResultReset());
    setFocusOnInput();
  };

  useEffect(() => {
    if (!previousIsLargeMode && isLargeMode && !defaultOpen) setFocusOnInput();
  }, [isLargeMode]);

  useEffect(() => {
    if (loading) {
      setIsLargeMode(false);
    }
    if (!loading && visible && persons.length < 1) {
      setVisiblePopup(false);

      setSearchText('');
      setIsCrossVisible(false);
    }
  }, [loading]);
  useEffect(() => {
    if (defaultOpen) {
      setIsLargeMode(true);
    }
  }, [defaultOpen]);
  useEffect(() => {
    if (defaultOpen && selectedPerson.personId !== undefined && !showPopUp && !affintyLoading) {
      setVisiblePopup(true);
    }
  }, [selectedPerson, affintyLoading]);

  const onEnter = () => {
    dispatch(certificationActions.certificationAction({
      type: 'affinity_section',
      source: 'person',
      data,
    }));
  };

  return (
    <Waypoint onEnter={onEnter}>
      <SearchWrapper
        className={classNames(`global-search-dropdown affinity-search-widget ${modeCSSMap[searchMode]} z-index-1 min-height`, { personYouName: personYouFlag })}
        onClick={enableLargeMode}
      >
        {
          selectedPerson && (selectedPerson.personId !== undefined
            || selectedPerson.personId !== 0) && (
            <AffinitySearchPopup
              visible={visible}
              persona={selectedPerson.archeType && selectedPerson.archeType.color}
              logo={selectedPerson.personImage}
              personId={selectedPerson.personId}
              personName={selectedPerson.personName}
              personDesignation={selectedPerson.personDesignation}
              personalityTypes={selectedPerson.personalityTypes}
              profileId={profileId}
              togglePopup={(bool: boolean) => setVisiblePopup(bool)}
            />
          )
        }
        {isMobSm ? null : (
          <OutsideClickHandler onOutsideClick={onBlur}>
            <div
              className="input-dropdown-wrapper"
            >
              <Input
                size="small"
                placeholder={defaultOpen ? 'Search your profile...' : 'Enter person name here...'}
                prefix={<SearchGlobalIcon />}
                className={`search-field ${translateSkipAreas}`}
                onChange={onSearchTextChange}
                value={searchText}
                ref={inputRef}
                onKeyDown={triggerSearch}
                maxLength={50}
              />
              {isLargeMode ? <AffinitySearchResults onSelect={disableLargeMode} /> : null}
              <Cross className={`clear-search ${isCrossVisible ? 'pointer-cursor' : 'disabled'} shrink-mode-positioning`} onClick={clearSearch} />
            </div>
          </OutsideClickHandler>
        )}
        {loading && !isLargeMode && <AffinitySearchNameSkeleton />}
        {((!isLargeMode && !loading) || isMobSm)
          && (
            <Tooltip
              arrow={false}
              placement="topLeft"
              getPopupContainer={(e: HTMLElement) => e}
              className="triggers-bullet-tooltip affinity-name-tooltip"
              color="#fff"
              title={name}
            >
              <PersonName className={classNames('text-truncate search-field-text')}>{name}</PersonName>
            </Tooltip>
          )}
      </SearchWrapper>
    </Waypoint>
  );
};

export default AffinitySearch;
